import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import { AppService } from '@services/app.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {
  public nuevoForm: FormGroup;
  public editForm: FormGroup;
  public isAuthLoading = false;


  public user: any = null;
  usuarios: any = [];
  pagesNumber: any;
  offset= 3;
  page= 1;  
  public cargando = false;
  findInput: any;


  constructor( public router: Router,private toastr: ToastrService, private appService: AppService, private http: HttpClient) { }

  ngOnInit(): void {
    this.user = this.appService.user;    
    this.getUsuarios();  
    
    this.nuevoForm = new FormGroup({
      nombre: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      celular: new FormControl(null, Validators.required),
      perfil_id: new FormControl(null, Validators.required),
    });   
    
    this.editForm = new FormGroup({
      id: new FormControl(null, Validators.required),
      fotografia: new FormControl(null, Validators.nullValidator),
      fotografia_url: new FormControl(null, Validators.nullValidator),      
      nombre: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.nullValidator),
      celular: new FormControl(null, Validators.nullValidator),
      password: new FormControl(null, Validators.required),
      perfil_id: new FormControl(null, Validators.required),
      estado: new FormControl(null, Validators.required),
    });       

  }

  getUsuarios(){
    this.appService.getUsuarios(this.user.perfil+'-'+this.user.et+'-'+this.page).subscribe( (data) => {
    this.usuarios = data['usuarios']; 
    this.ForpagesNumber();
    // console.log(this.usuarios);       
    this.cargando = false;
    });
  }


  changePage(page) {
    this.page = page; //para el filtro
    this.usuarios.current = page;
    this.getUsuarios();
  }
  
  ForpagesNumber() {
    let from = this.usuarios.current - this.offset;
    if(from < 1){
      from = 1;
    }

    let to = from + (this.offset * 2); 
    if(to >= this.usuarios.total_page){
      to = this.usuarios.total_page;
    }

    let pagesArray = [];
    while(from <= to){
      pagesArray.push(from);
      from++;
    }
    this.pagesNumber = pagesArray;
    // return pagesArray;
  }


  async newUsuario() {     
    if (this.nuevoForm.valid) {
        this.isAuthLoading = true; 
          let params = {
              nuevo:true,
              nombre: this.nuevoForm.value.nombre,
              email: this.nuevoForm.value.email,
              password: this.nuevoForm.value.password,
              perfil_id: this.nuevoForm.value.perfil_id,
              estado: 1,
              empresa_id: this.user.eid
            };
            // console.log(params);
            this.appService.postUsuario(params)
          .subscribe( (data) => {
              if (data["logger"] == true){
                  this.nuevoForm.reset()
                  $('#nuevaUsuario').modal('hide');
                  this.getUsuarios();
              }else{
                  this.toastr.error(data["msg"]);
              }
          }); 
        this.isAuthLoading = false;
    } else {
        this.toastr.error('El formulario no es válido!');
    }
  }

  verUsuario(item){
    this.editForm.get('id').setValue(item.id);
    this.editForm.get('fotografia').setValue(item.fotografia);
    this.editForm.get('fotografia_url').setValue(item.fotografia_url);
    this.editForm.get('nombre').setValue(item.nombre);
    this.editForm.get('email').setValue(item.email);
    this.editForm.get('password').setValue(item.password);
    this.editForm.get('perfil_id').setValue(item.perfil_id);
    this.editForm.get('celular').setValue(item.celular);
    this.editForm.get('estado').setValue(item.estado);
  }

  async editUsuario(){    
    if (this.editForm.valid) {
      this.isAuthLoading = true; 
        let params = {
            editar:true,
            id: this.editForm.value.id,
            nombre: this.editForm.value.nombre,
            email: this.editForm.value.email,
            celular: this.editForm.value.celular,
            password: this.editForm.value.password,
            perfil_id: this.editForm.value.perfil_id,
            estado: 1,
            empresa_id: this.user.eid
          };
          // console.log(params);
          this.appService.postUsuario(params)
        .subscribe( (data) => {
            if (data["logger"] == true){
                this.editForm.reset()
                $('#verUsuario').modal('hide');
                this.getUsuarios();
            }else{
                this.toastr.error(data["msg"]);
            }
        }); 
      this.isAuthLoading = false;
  } else {
      this.toastr.error('El formulario no es válido!');
  }
  }

  async eliminarUsuario(item){
    Swal.fire({
      title: '¿Está seguro?',
      text: `Desea eliminar al usuario?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, estoy seguro!',
    }).then((result) => {
      if (result.value) {        
        let params = {
          eliminar : true,
          id: item.id,
          empresa_id: this.user.eid
        }
        this.appService.postUsuario(params)
        .subscribe( (data) => {
            if (data["logger"] == true){
                this.getUsuarios();
                this.toastr.success(data["msg"]);
            }else{
                this.toastr.error(data["msg"]);
            }
        });         

      }
    });  

  }

  async find() {
    let params = {
      buscar: true,
      buscar_input: this.findInput,
      page: this.page,
      et: this.user.et,
    };
    this.appService.postUsuario(params)
      .subscribe((data) => {
        if (data["logger"] == true) {
          this.usuarios = data['obj'];
          this.ForpagesNumber();
        } else {
          this.toastr.error(data["msg"]);
        }
      });
  }

}
